import PropertiesService from '@/api/admin/properties.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    statuses: [],
    propertiesModel: {},
  },
  getters: {
    allProperties: state => state.table,
    allPropertiesStatuses: state => state.statuses,
    getPropertiesModel: state => state.propertiesModel,
  },
  actions: {
    async getProperties({ commit }) {
      const properties = await PropertiesService.getProperties()
      commit('SET_PROPERTIES', properties)
      commit('SET_TOTALRECORDS', properties.totalRecords)
      commit('SET_PROPERTIES_STATUSES', properties.statuses)
      commit('SET_PROPERTIES_MODEL', properties)
    },
    async getFilteredProperties({ commit }, filter) {
      const properties = await PropertiesService.getFilteredProperties(filter)
      commit('SET_PROPERTIES', properties)
      commit('SET_TOTALRECORDS', properties.totalRecords)
      commit('SET_PROPERTIES_STATUSES', properties.statuses)
      commit('SET_PROPERTIES_MODEL', properties)
    },
  },
  mutations: {
    SET_PROPERTIES(state, properties) {
      state.table.rows = properties.properties
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_PROPERTIES_STATUSES(state, status) {
      state.statuses = status
    },
    SET_PROPERTIES_MODEL(state, propertiesModel) {
      state.propertiesModel = propertiesModel
    },
  },
}
